import React from "react";
import PhotographerCard from "./PhotographerCard";
import "../../styles/components/browse_photographers_page/PhotographerGrid.css";

export default function PhotographerGrid({
  photographers,
  onHoverIn,
  onHoverOut,
  onSelect,
  selectedSub,
}) {
  return (
    <div className="photographer-grid">
      {photographers.map((photographer) => (
        <PhotographerCard
          key={photographer.sub}
          photographer={photographer}
          onHoverIn={onHoverIn}
          onHoverOut={onHoverOut}
          onSelect={onSelect}
          isSelected={photographer.sub === selectedSub}
        />
      ))}
    </div>
  );
}
